export enum PaymentEvents {
    Valid = "VALID_PAYMENT_METHOD",
    Invalid = "INVALID_PAYMENT_METHOD",
    Saved = "PAYMENT_METHOD_SAVED",
    Removed = "PAYMENT_METHOD_REMOVED",
    Exists = 'HAS_PAYMENT_METHOD',
    NotExists = 'NO_PAYMENT_METHOD',
    Changed = 'PAYMENT_METHOD_CHANGED',
    MissingInput = 'MISSING_INPUT'
}